<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.87" clip-path="url(#clip0_185_3888)">
      <path
        d="M4.40541 31.5367C4.82703 31.8455 5.24865 31.9999 5.67027 31.9999C6.09189 31.9999 6.51351 31.8455 6.93513 31.5367L27.7351 18.4125C28.4378 17.9493 29 17.0229 29 
          15.942C29 14.8612 28.5784 13.9348 27.7351 13.4716L6.93513 0.347346C6.09189 -0.115863 5.10811 -0.115863 4.26486 0.347346C3.56216 0.810554 3 1.73697 3 2.81779V29.0663C3 
          30.1471 3.56216 31.0735 4.40541 31.5367Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_185_3888">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
